import React from "react";
import Layout from "../components/Layout";
// import Topbar from "../components/Topbar";
import NavOne from "../components/NavOne";
import SliderOne from "../components/SliderOne";
import Footer from "../components/Footer";
import AboutTwo from "../components/AboutTwo";
import CourseOne from "../components/CourseOne";
import VideoTwo from "../components/VideoTwo";
import CourseCatOne from "../components/CourseCatOne";
import CallToActionThree from "../components/CallToActionThree";
import BrandsTwo from "../components/BrandsTwo";
import BlogTwo from "../components/BlogTwo";
import SubscribeOne from "../components/SubscribeOne";

const HomePage = () => (
  <Layout pageTitle="苏州卫捷医药科技有限公司">
    {/* <Topbar /> */}
    <NavOne />
    <SliderOne />
    <AboutTwo />
    <CourseOne />
    <VideoTwo />
    {/* <CountdownKipso /> */}
    <CourseCatOne />
    <CallToActionThree />
    <BrandsTwo />
    <BlogTwo />
    {/* <CallToActionFour /> */}
    <SubscribeOne />
    <Footer />
  </Layout>
);

export default HomePage;
